import { useMutation } from '@tanstack/vue-query';
import { getApi } from '../api';

export default () => useMutation({
    mutationFn: ({ accountId, id, data }: { accountId: number; id: number; data: object }) => {
        const { api, baseURL } = getApi();
        return api.put(`/api/v2/accounts/${accountId}/map-overlays/${id}`, data, { baseURL }).then(res => res.data.data);
    },
});
